// Mirrors sass variables for media queries
// @see _settings.scss
export const breakpoints = {
  giant: 1367,
  desktop: 1024,
  tablet: 768,
  phone: 480,
};
